import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { InputCustom, HttpError, SelectCustom } from "../components"
import { LoadModal } from "./modais"
import Layout from "../views/Layout"
import * as ApiHelper from "../ApiHelper"
import Util from "../Util"
class RelatorioLogs extends Component {
  constructor() {
    super()
    this.sendForm = this.sendForm.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.onChangeDataInicio = this.onChangeDataInicio.bind(this)
    this.onChangeDataFinal = this.onChangeDataFinal.bind(this)
    this.onChangeUsuario = this.onChangeUsuario.bind(this)
    this.state = {
      dataDeInicio: "",
      dataFinal: "",
      usuarios: [],
      usuario: "",
      showLoad: false
    }
  }

  componentWillMount() {
    this.getInitialFields()
  }
  componentDidUpdate() {
    //Pequeno ajuste tecnico devido bug no datepicker
    window.$(".is-empty").removeClass("is-empty")
  }

  getInitialFields() {
    ApiHelper.getUsuarios((data, error) => {
      if (data) {
        this.setState(
          {
            usuarios: Util.mapCidades(data)
          },
          () => {
            window.$(".is-empty").removeClass("is-empty")
          }
        )
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  onChangeDataInicio(value) {
    var newValue = value
    this.setState({
      dataDeInicio: newValue
    })
  }
  onChangeDataFinal(value) {
    var newValue = value
    this.setState({
      dataFinal: newValue
    })
  }
  onChangeUsuario(event) {
    var newValue = event.target.value
    this.setState({
      usuario: newValue
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  sendForm(event) {
    event.preventDefault()
    var params = {
      end_date: this.state.dataFinal,
      start_date: this.state.dataDeInicio,
      user_id: this.state.usuario === "" ? undefined : this.state.usuario
    }
    this.toggleLoadModal()
    ApiHelper.getLogsReport(params, relatorio => {
      this.toggleLoadModal()
      if (relatorio) {
        var url = URL.createObjectURL(relatorio)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute("download", "Relatório de atividades.pdf")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        this.setState({
          formError: "Ocorreram erros"
        })
      }
    })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.erros
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  render() {
    if (this.state.httpError) {
      return (
        <HttpError
          message={this.state.httpError.message}
          status={this.state.httpError.status}
        />
      )
    }
    return (
      <Layout>
        <div className="card card-plain">
          <div className="card-header" data-background-color="as-blue">
            <h4 className="title">Relatório de atividades realizadas</h4>
            <p className="category">
              Todas as atividades realizadas pelos vários operadores do sistema
            </p>
          </div>
          <div className="card-content">
            <div className="row card">
              <LoadModal
                onClose={this.toggleLoadModal}
                show={this.state.showLoad}
              />
              <SelectCustom
                error={this.state.formError}
                sizeClass="col-md-3"
                options={this.state.usuarios}
                label="Usuário"
                onChange={this.onChangeUsuario}
                value={this.state.usuario}
              />
              <InputCustom
                sizeClass="col-md-3"
                type="date"
                label="Data inicial"
                onChange={this.onChangeDataInicio}
                value={this.state.dataDeInicio}
              />
              <InputCustom
                sizeClass="col-md-3"
                type="date"
                label="Data final"
                onChange={this.onChangeDataFinal}
                value={this.state.dataFinal}
              />
              <div className="row">
                <button
                  onClick={this.sendForm}
                  type="submit"
                  className="btn btn-primary pull-left"
                  data-background-color="as-blue"
                >
                  Gerar
                </button>
              </div>
            </div>
            <span className="label label-primary">
              PS: Se as datas forem deixadas em branco, todo o período de
              existencia do sistema será contemplado
            </span>
          </div>
        </div>
      </Layout>
    )
  }
}
export default withRouter(RelatorioLogs)



// WEBPACK FOOTER //
// ./src/views/RelatorioLogs.js